import { render, staticRenderFns } from "./asideBar.vue?vue&type=template&id=17895890&scoped=true&"
import script from "./asideBar.vue?vue&type=script&lang=js&"
export * from "./asideBar.vue?vue&type=script&lang=js&"
import style0 from "./asideBar.vue?vue&type=style&index=0&id=17895890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17895890",
  null
  
)

export default component.exports